// What a viewer said about an asset through a rating overlay, on the `visitor` surface.

import { visitor } from '../client'
import type { components } from '../visitor.schema'

export type SubmitRatingRequest = components['schemas']['SubmitRatingRequest']

/**
 * One rating per session: a re-post is the same 204 and changes nothing. 503 on a deployment that
 * records no analytics.
 */
export function submitRating(request: SubmitRatingRequest): Promise<void> {
  return visitor.post<void>('/ratings/', request)
}
